class Number {
  static isNotNull = value => {
    return (
      value &&
      value !== null &&
      value !== undefined &&
      value !== "" &&
      value !== "null" &&
      value !== "undefined"
    );
  };
}

export default Number;
